<template>
    <div class="chartBox">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2 flexStart">
                <div style="color:#5cd9e8;margin-right: 10px;">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="flexStart">
                    <span class="fs-xl text mx-2" style="margin-right: 10px;">
						{{$store.state.pmid==7?'各系招生情况':''}}
						{{$store.state.pmid!=7?'各系收费情况（元）':''}}
					</span>
                    <dv-decoration-1 style="width:30%;height:1rem;" />
                </div>
            </div>
            <div class="d-flex jc-center body-box feeContainer" style="height:calc(100% - 30px);margin-top: 10px;">
                <dv-capsule-chart :config="config" style="width: 100%;height:100%" />

            </div>
        </div>
    </div>
</template>

<script>
	import echartMixins from "../../js/resizeMixins";

	export default {
		data () {
			return {};
		},
		props: {
			config: {
				type: Object,
				default: {
					data:[],
					colors: ['#37A2DA', '#32c5e9', '#67E0E3', '#9FE6B8', '#FFDB5C'],
					unit: '元',
					showValue: true
				}
			},
		},
		mixins: [echartMixins],
		mounted () {},
		methods: {},
		destroyed () {
			window.onresize = null;
		}
	};
</script>
<style lang="less" type="text/less">
    .feeContainer{
        .dv-capsule-chart{
            padding-bottom: 0;
            .capsule-container{
                flex: 0 0 60%;
            }
        }
        .unit-label{
            div{
                color: #0d1224;

            }
        }
        .unit-text{
            color: #0d1224;
            //color: pink;
        }
    }
</style>
<style scope lang="less" type="text/less">
    .chartBox {
        width: 100%;height: 100%;
    }
</style>
